<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
        @change="getCollegeList"
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="listQuery.college_id"
        placeholder="请选择院系"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
        @change="getMajorList"
      >
        <el-option
          v-for="item in colleges"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="listQuery.major_id"
        placeholder="请选择专业"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
      >
        <el-option
          v-for="item in majors"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="listQuery.school_year"
        type="year"
        class="filter-item"
        value-format="yyyy"
        placeholder="选择学年"
        style="margin-right: 10px"
        @change="getGradeList"
      >
      </el-date-picker>
      <el-select
        v-model="listQuery.semester"
        placeholder="请选择学期"
        clearable
        style="width: 150px; margin-right: 10px"
        class="filter-item"
      >
        <el-option label="第一学期" :value="1" />
        <el-option label="第二学期" :value="2" />
      </el-select>
      <el-select
        v-model="listQuery.grade_id"
        placeholder="请选择年级"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
        @change="getClassList"
      >
        <el-option
          v-for="item in grades"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="listQuery.class_id"
        placeholder="请选择班级"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
        @change="getCourseList()"
      >
        <el-option
          v-for="item in classes"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="listQuery.school_course_id"
        placeholder="请选择课程"
        clearable
        style="width: 150px; margin-right: 10px"
        class="filter-item"
      >
        <el-option
          v-for="item in courses"
          :key="item.id"
          :label="item.school_course.name"
          :value="item.school_course.id"
        ></el-option>
      </el-select>

      <el-select
        v-model="listQuery.type"
        placeholder="请选择状态"
        clearable
        style="width: 150px; margin-right: 10px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="代课" :value="2" />
        <el-option label="调课" :value="3" />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="是否放假"
        clearable
        style="width: 150px; margin-right: 10px"
        class="filter-item"
      >
        <el-option label="是" :value="'stop_class'" />
        <el-option label="否" :value="'normal'" />
      </el-select>
      <el-date-picker
        v-model="Timedate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        class="filter-item"
        @change="changeDate"
      >
      </el-date-picker>
      <el-button class="filter-item" type="primary" @click="getList"
        >查找</el-button
      >
    </div>

    <div class="title">
      <span>
        总课时: 共 {{ count ? count.total_num + count.stop_class_num : 0 }} 课时  </span>
      <span>实上课时: 共 {{ count ? count.total_num : 0 }} 课时  </span>
      <span>放假课时: 共 {{ count ? count.stop_class_num : 0 }} 课时  </span
      ><br />

      <span>正常课时: 共 {{ count ? count.nomal_num : 0 }} 课时  </span>
      <span>代课课时：共 {{ count ? count.replace_num : 0 }} 课时  </span>
      <span>调课课时: 共 {{ count ? count.change_num : 0 }} 课时  </span><br />

      <span>设置作业次数: 共 {{ count ? count.homework_num : 0 }} 次</span>
      <br />

      <span>出勤率: {{ count ? count.total_sign_in_rate : 0 }}%</span>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" min-width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="课程" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.school_course.name }}
        </template>
      </el-table-column>
      <el-table-column label="上课教师" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.teacher.name }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.classes.college.school.name }}
        </template>
      </el-table-column>
      <el-table-column label="学年" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.classes.school_year }}~{{
            scope.row.class_course.classes.school_year - 0 + 1
          }}
        </template>
      </el-table-column>
      <el-table-column label="学期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.semester == 1 ? "第一学期" : "第二学期" }}
        </template>
      </el-table-column>
      <el-table-column label="院系" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.classes.college.name }}
        </template>
      </el-table-column>
      <el-table-column label="年纪" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.classes.grade.name }}
        </template>
      </el-table-column>
      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_course.classes.name }}
        </template>
      </el-table-column>
      <el-table-column label="日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.date }}
        </template>
      </el-table-column>
      <el-table-column label="第几节" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_time_config.name }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1">正常</el-tag>
          <el-tag v-if="scope.row.type == 2">代课</el-tag>
          <el-tag v-if="scope.row.type == 3">调课</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否放假" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'stop_class'">是</el-tag>
          <el-tag v-if="scope.row.status == 'normal'">否</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="备注" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_time_config.name }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleJobManagement(scope.row)"
            >作业管理</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="handleStudent(scope.row)"
            >查看学生</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listQuery: {
        page: 1,
        limit: 10,
        school_id: null,
        college_id: null,
        major_id: null,
        school_year: null,
        semester: null,
        grade_id: null,
        class_id: null,
        type: null,
        teacher_id: null,
      },
      list: [],
      total: null,
      listLoading: false,
      form: {
        id: "",
      },
      schools: [],
      colleges: [],
      majors: [],
      grades: [],
      classes: [],
      courses: [],
      count: {},
      total_num: null,
      nomal_num: null,
      replace_num: null,
      change_num: null,
      teacher_id: null,
      Timedate: null,
    };
  },
  created() {
    this.listQuery.teacher_id = this.$route.query.teacher_id;
    this.getSchoolList();
    this.getList();
  },
  watch: {
    Timedate(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (!newValue) {
        this.listQuery.start_at = null;
        this.listQuery.end_at = null;
      }
    },
  },
  methods: {
    //获取课程
    getCourseList() {
      request({
        url: "/api/backend/eduAdmin/courseList",
        method: "get",
        params: {
          limit: 99999999999999,
          // school_id: this.listQuery.school_id,
          // semester: this.listQuery.semester,
          // school_year: this.listQuery.school_year,
          // teacher_id:this.listQuery.teacher_id,
          // is_select:1,
          ...this.listQuery,
        },
      }).then((response) => {
        this.courses = response.data.data;
        this.$forceUpdate(); //强制更新
      });
    },
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: {
          limit: 99999999999999999,
        },
      }).then((response) => {
        this.schools = response.data.data;
      });
    },
    getCollegeList() {
      request({
        url: "/api/backend/school/collegeList",
        method: "get",
        params: {
          limit: 99999999999999999,
          school_id: this.listQuery.school_id,
        },
      }).then((response) => {
        this.colleges = response.data.data;
      });
    },
    getMajorList() {
      request({
        url: "/api/backend/school/majorList",
        method: "get",
        params: {
          limit: 99999999999999999,
          college_id: this.listQuery.college_id,
        },
      }).then((response) => {
        this.majors = response.data.data;
      });
    },
    getGradeList() {
      request({
        url: "/api/backend/school/gradeList",
        method: "get",
        params: {
          limit: 99999999999999999,
          school_id: this.listQuery.school_id,
          school_year: this.listQuery.school_year,
        },
      }).then((response) => {
        this.grades = response.data.data;
      });
    },
    getClassList() {
      request({
        url: "/api/backend/school/classList",
        method: "get",
        params: {
          limit: 99999999999999999,
          college_id: this.listQuery.college_id,
          major_id: this.listQuery.major_id,
          grade_id: this.listQuery.grade_id,
          school_year: this.listQuery.school_year,
        },
      }).then((response) => {
        this.classes = response.data.data;
      });
    },
    handleJobManagement(row) {
      this.$router.push(
        `/schedule/operation?schedule_id=${row.id}&data=${JSON.stringify(row)}`
      );
    },
    handleStudent(row) {
      this.$router.push(
        `/schedule/student?class_id=${row.class_course.class_id}`
      );
    },
    changeDate() {
      if (!this.Timedate || this.Timedate.length == 0) {
        return;
      }
      this.listQuery.start_at = this.Timedate[0];
      this.listQuery.end_at = this.Timedate[1];
    },
    getList() {
      this.listLoading = true;
      console.log(this.listQuery);
      request({
        url: "/api/backend/schedule/scheduleLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.count = response.data.count;
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
  flex-wrap: wrap;
}
.filter-item {
  margin-bottom: 10px;
}
.title {
  margin-bottom: 10px;
}
.el-table--border th.gutter:last-of-type {
  display: block !important;
}
.tip_box {
  display: flex;
  align-items: center;
  .tip {
    width: 20px;
    height: 20px;
    margin: 0 20px 0 5px;
  }
  .color_1 {
    background: black;
  }
  .color_2 {
    background: #11eeee;
  }
  .color_3 {
    background: #4db34d;
  }
  .color_4 {
    background: red;
  }
}
</style>
